/* eslint-disable max-len */
import React, { useState } from "react";
import { Card, CardBody, Button } from "reactstrap";
import { Edit, X, Save } from "react-feather";
import styled from "styled-components";
import useFetcher from "../../hooks/useFetcher";
import { fetchPiAsignable, fetchPiDerivadores } from "../../services/ticketingServices";
import { fetchSucursales } from "../../services/sucursalServices";
import { fetchRegiones } from "../../services/regionServices";
import { BlurSpinner } from "../../components/BlurSpinner";
// import { fetchCasasCentrales } from "../../services/casaCentralServices";
import { retriveRegionSucursalOptions } from "../../utils/retriveRegionSucursalOptions";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";
import { LabSelect } from "../../components/course/select";
import { getStylesByOrigen } from "../NotasDePedido/utils";

export const Container = styled.div`
  .font {
    font-family: "Nunito" !important;
  }
`;

const getPiById = (id, pis) => {
  const pi = pis.find((objeto) => objeto.itemId === id);
  return pi ? pi.nombreApellido : "-";
};

const getSucursalById = (id, sucursales) => {
  const sucursal = sucursales.find((objeto) => objeto.itemId === id);
  return sucursal ? sucursal.titulo : "-";
};

// Si el servicio es PP, muestra servicio ofrecido o subservicio
export const getServicioToShow = (servicio, nota) => {
  const { servicioCat, servicioOfrecido } = nota || {};
  const { subservicio } = nota.servicioSubservicio || {};

  if (servicio !== 1) {
    return (servicioCat && servicioCat.text) || "-";
  }

  return (servicioOfrecido && servicioOfrecido.nombre) || subservicio || servicioCat.text || "-";
};

const getBusinessLineById = (id, businessLines, onsiteServicios, serviciosCentralizado) => {
  if (onsiteServicios && onsiteServicios === 1) {
    return "Onsite";
  }
  if (serviciosCentralizado && serviciosCentralizado === 1) {
    return "Centralizado";
  }
  const businessLine = businessLines.find((objeto) => objeto.id === id);
  return businessLine ? businessLine.text : "-";
};

const DetalleNP = ({ nota, anularCancelar, handleEditData, categories }) => {
  const { currentUser, haveSucursalesAccess } = useAuth();
  const [pisAsignable, isLoadingPisAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [piDerivadores, isLoadingPiDerivadores] = useFetcher(fetchPiDerivadores, undefined, "allfetchPiDerivadores");
  const pisLista = pisAsignable && piDerivadores ? [...pisAsignable, ...piDerivadores] : [];
  const recruiter = nota.piRecruiter && pisLista ? nota.piRecruiter.nombreApellido : getPiById(nota.recruiter, pisLista);
  const sourcer = nota.piSourcer && pisLista ? nota.piSourcer.nombreApellido : getPiById(nota.sourcer, pisLista);
  const creador = nota.creador && pisLista ? nota.creador.nombreApellido : getPiById(nota.creadoPor, pisLista);
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const sucursal = nota && nota.sucursalId ? getSucursalById(nota.sucursalId, sucursales) : "sin sucursal";
  const [modifyingRecruiter, setModifyingRecruiter] = useState(false);
  const [modifyingSourcer, setModifyingSourcer] = useState(false);
  const [piAsignable, isLoadingPiAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [recruiterValue, setRecruiterValue] = useState(recruiter);
  const [sourcerValue, setSourcerValue] = useState(sourcer);
  const estados = categories && categories.estadoNP;
  const businessLineEnum = categories && categories.businessLine && categories.businessLine.type;
  // const [casasCentrales, isLoadingCasasCentrales] = useFetcher(fetchCasasCentrales, undefined, "fetchCasasCentrales");

  // se elimina la region CASA CENTRAL por defecto de las regiones
  const casasCentralesVacio = [];
  // const regionesFiltered = regiones.filter((r) => r.itemId !== 1513699737);

  const helperRegionSucursal = retriveRegionSucursalOptions(
    nota.region,
    nota.sucursalId,
    regiones,
    sucursales,
    casasCentralesVacio,
    isLoadingRegiones || isLoadingSucursales,
    haveSucursalesAccess(modulos.NOTAS_DE_PEDIDO),
    currentUser.user
  );

  let recruiterFilteres = piAsignable;
  let sourcerFilteres = piAsignable;
  if (helperRegionSucursal.selectedRegion || helperRegionSucursal.selectedSucursal) {
    recruiterFilteres = piAsignable.filter((pi) => {
      const sucursalesPi = (pi.CasaCentral || []).concat(pi.SucursalesAsignadas || []);
      return (
        (!helperRegionSucursal.selectedRegion || sucursalesPi.map((suc) => suc.region2).includes(helperRegionSucursal.selectedRegion)) &&
        (!helperRegionSucursal.selectedSucursal || sucursalesPi.map((suc) => suc.itemId).includes(helperRegionSucursal.selectedSucursal))
      );
    });
  }

  // filtra por Pis con puesto RECRUITER, SOURCER, CONSULTANT, ONSITE o ONSITE C para mostrarlos en el select
  // Tambien los recruiters son filtrados por Region/Sucursal
  recruiterFilteres = recruiterFilteres.filter(
    (pi) =>
      (pi.posicionCat && pi.posicionCat.text === "RECRUITER") ||
      (pi.posicionCat && pi.posicionCat.text === "SOURCER") ||
      (pi.posicionCat && pi.posicionCat.text === "ONSITE") ||
      (pi.posicionCat && pi.posicionCat.text === "ONSITE C")
  );

  // Se agrega a las opciones de recruiter todos los pis con posicion CONSULTANT
  // sin filtrar por Region/Sucursal
  const pisConsultants = piAsignable.filter((pi) => pi.posicionCat && pi.posicionCat.text === "CONSULTANT");
  recruiterFilteres.push(...pisConsultants);

  // filtra por Pis con puesto SOURCER, RECRUITER, CONSULTANT, ONSITE o ONSITE C para mostrarlos en el select
  sourcerFilteres = sourcerFilteres.filter(
    (pi) =>
      (pi.posicionCat && pi.posicionCat.text === "SOURCER") ||
      (pi.posicionCat && pi.posicionCat.text === "RECRUITER") ||
      (pi.posicionCat && pi.posicionCat.text === "CONSULTANT") ||
      (pi.posicionCat && pi.posicionCat.text === "ONSITE") ||
      (pi.posicionCat && pi.posicionCat.text === "ONSITE C")
  );

  const recruiterOptions = recruiterFilteres
    ? recruiterFilteres
        .map((e) => {
          return { label: e.nombreApellido, value: e.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const sourcerOptions = sourcerFilteres
    ? sourcerFilteres
        .map((e) => {
          return { label: e.nombreApellido, value: e.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const getRegionTitleById = (id) => {
    const region = regiones.find((item) => item.itemId === id);
    return region ? region.title : null;
  };

  function getFunctionToFilter(filter, selected) {
    if (filter === "recruiter") {
      setRecruiterValue(selected);
    }
    if (filter === "sourcer") {
      setSourcerValue(selected);
    }
  }
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const handleRecruiterChange = () => {
    handleEditData({ recruiter: recruiterValue.value });
    setModifyingRecruiter(!modifyingRecruiter);
  };
  const handleSourcerChange = () => {
    handleEditData({ sourcer: sourcerValue.value });
    setModifyingSourcer(!modifyingSourcer);
  };

  return (
    <>
      <Card className="h-100 mb-0">
        <BlurSpinner isLoading={isLoadingPisAsignable || isLoadingPiDerivadores || isLoadingSucursales || isLoadingRegiones}>
          <CardBody className="py-3">
            <Container>
              <div className="text-muted font d-flex justify-content-between">
                Región:
                {nota.origen && [1, 2, 3].includes(nota.origen) && estados ? (
                  <div
                    className="d-flex justify-content-center"
                    style={{
                      fontSize: "10px",
                      ...getStylesByOrigen(nota.origen),
                      borderRadius: "5px",
                      padding: "4px",
                      minWidth: "40px",
                    }}
                  >
                    <span>{estados.origen.find((o) => o.id === nota.origen).text}</span>
                  </div>
                ) : null}
              </div>
              <div className="d-flex justify-content-between align-items-center font">{nota ? getRegionTitleById(nota.region) : "-"}</div>
              <hr className="my-3" />
              <div className="text-muted font">Sucursal: </div>
              <div className="d-flex justify-content-between align-items-center font">{sucursal || "-"}</div>
              <hr className="my-3" />
              <div className="text-muted font">Servicio: </div>
              <div className="d-flex justify-content-between align-items-center font">{nota ? getServicioToShow(nota.servicio, nota) : "-"}</div>
              <hr className="my-3" />
              <div className="text-muted font">Subcliente: </div>
              <div className="d-flex justify-content-between align-items-center font">{nota ? nota.subClienteLegajo : "-"}</div>
              <hr className="my-3" />
              <div className="text-muted font">Business Line </div>
              <div className="d-flex justify-content-between align-items-center font">
                {nota && nota.cliente && nota.cliente.businessLine
                  ? getBusinessLineById(nota.cliente.businessLine, businessLineEnum, nota.cliente.onsiteServicios, nota.cliente.serviciosCentralizado)
                  : "-"}
              </div>
              <hr className="my-3" />
              <div className="text-muted font">Recruiter: </div>
              <div className="d-flex justify-content-between align-items-center font">
                {modifyingRecruiter ? (
                  <>
                    <LabSelect
                      id="recruiter"
                      name="recruiter"
                      className="w-100"
                      onChange={handleReactSelectChange}
                      value={recruiterValue}
                      placeholder="Todo"
                      isClearable
                      isLoading={isLoadingPiAsignable}
                      isDisabled={isLoadingPiAsignable}
                      options={recruiterOptions}
                    />
                    <div style={{ width: "25px" }}>
                      <Button size="xs" color="link" onClick={() => handleRecruiterChange()}>
                        <Save size="20" color="#293134" />
                      </Button>
                      <Button size="xs" color="link" onClick={() => setModifyingRecruiter(!modifyingRecruiter)}>
                        <X size="20" color="#293134" />
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    {recruiter || "-"}

                    <div>
                      <Button size="xs" id="btnModifyingAsignado" color="link" onClick={() => setModifyingRecruiter(!modifyingRecruiter)} disabled={anularCancelar}>
                        <Edit size="20" color="#293134" />
                      </Button>
                    </div>
                  </>
                )}
              </div>
              <hr className="my-3" />
              <div className="text-muted font">Sourcer: </div>
              <div className="d-flex justify-content-between align-items-center font">
                {modifyingSourcer ? (
                  <>
                    <LabSelect
                      id="sourcer"
                      name="sourcer"
                      className="w-100"
                      onChange={handleReactSelectChange}
                      value={sourcerValue}
                      placeholder="Todo"
                      isClearable
                      isLoading={isLoadingPiAsignable}
                      isDisabled={isLoadingPiAsignable}
                      options={sourcerOptions}
                    />
                    <div style={{ width: "25px" }}>
                      <Button size="xs" color="link" onClick={() => handleSourcerChange()}>
                        <Save size="20" color="#293134" />
                      </Button>
                      <Button size="xs" color="link" onClick={() => setModifyingSourcer(!modifyingSourcer)}>
                        <X size="20" color="#293134" />
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    {sourcer || "-"}

                    <div>
                      <Button size="xs" id="btnModifyingAsignado" color="link" onClick={() => setModifyingSourcer(!modifyingSourcer)} disabled={anularCancelar}>
                        <Edit size="20" color="#293134" />
                      </Button>
                    </div>
                  </>
                )}
              </div>
              <hr className="my-3" />
              <div className="text-muted font">Creador: </div>
              <div className="d-flex justify-content-between align-items-center font">{creador || "-"}</div>
              <hr className="my-3" />
            </Container>
          </CardBody>
        </BlurSpinner>
      </Card>
    </>
  );
};

export default DetalleNP;
